import React from 'react';
import { Link } from 'react-router-dom';
import { HardHat, Home, PhoneCall } from 'lucide-react';
import SEO from '../components/SEO.js';

export default function NotFoundPage() {
  return (
    <div className="page-not-found animate-fade-in" style={{ padding: '6rem 0', textAlign: 'center', minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <SEO 
        title="404 - Page Not Found | Vijay Industry"
        description="The page you are looking for does not exist or has been moved."
        robots="noindex, follow"
        canonical="/404"
      />
      <div className="container">
        <div style={{ maxWidth: '600px', margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5rem' }}>
          <div style={{ color: 'var(--accent)', backgroundColor: '#FFF3E6', padding: '1.25rem', borderRadius: '50%', display: 'flex' }}>
            <HardHat size={48} />
          </div>
          
          <h1 style={{ fontSize: '4rem', fontWeight: 800, color: 'var(--primary)', margin: 0, lineHeight: 1 }}>404</h1>
          <h2 style={{ fontSize: '1.75rem', fontWeight: 700, color: 'var(--foreground)', margin: 0 }}>Page Not Found</h2>
          
          <p style={{ color: 'var(--muted)', fontSize: '1.05rem', lineHeight: 1.6, margin: 0 }}>
            The page you requested could not be found. It might have been removed, renamed, or is temporarily unavailable.
          </p>

          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center', marginTop: '1rem' }}>
            <Link to="/" className="btn btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
              <Home size={18} /> Return to Home
            </Link>
            <Link to="/contact" className="btn btn-secondary" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
              <PhoneCall size={18} /> Contact Support
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
